import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '返信封筒・手作業の抽選・膨大な紙書類による一斉入居調整を、スマホ完結の業務システムに刷新。マンション図面に基づく独自の抽選アルゴリズム開発でヒューマンエラーを排除し、不動産会社からの受注増加にも貢献したアート引越センターの開発事例です。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/mss/ogp_mss.png'

export const mssPageMeta: PageMeta = {
  title: 'アート引越センター 一斉入居の紙手続きをスマホ完結にDX化した業務システム開発事例 | Aitria（アイトリア）',
  description,
  keyword: 'UX/UI モバイルアプリ システム化 DX推進 SaaS フロントエンド開発',
  image: ogpImg,
  url: `${SITE_URL}/cases/mss/`,
}

export const mssSchema = buildCaseStudySchema({
  slug: 'mss',
  pageTitle: mssPageMeta.title,
  description: mssPageMeta.description,
  headline: '新築マンションの引越業務効率化をシステム開発で実現',
  alternativeHeadline: 'アート引越センター株式会社',
  primaryImage: ogpImg,
  images: [ogpImg, 'https://aitria.co.jp/images/img/cases/mss/top.png'],
  clientName: 'アート引越センター株式会社',
  breadcrumbLabel: '新築マンションの引越業務効率化をシステム開発で実現',
})
